import {
  APPEND_COMPANY_MEMBER_TAG,
  REMOVE_COMPANY_MEMBER_TAG,
  SET_COMPANIES,
  SET_COMPANY_DETAILS,
  SET_COMPANY_MEMBERS,
} from "../actionType";

const initState = {
  companies_list: [],
  company_details: {},
  company_members: {},
};

const companiesReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_COMPANIES:
      return {
        ...state,
        companies_list: action.payload,
      };
    case SET_COMPANY_DETAILS:
      return {
        ...state,
        company_details: {
          ...state.company_details,
          [action.payload.companyId]: action.payload.data,
        },
      };
    case SET_COMPANY_MEMBERS:
      return {
        ...state,
        company_members: {
          ...state.company_members,
          [action.payload.companyId]: action.payload.data,
        },
      };
    case APPEND_COMPANY_MEMBER_TAG:
      // eslint-disable-next-line no-case-declarations
      const members = state.company_members[action.payload.companyId].map(
        (member) => {
          if (member.slack_id === action.payload.slack_id)
            member.tags = [...member.tags, action.payload.data];
          return member;
        }
      );
      return {
        ...state,
        company_members: {
          ...state.company_members,
          [action.payload.companyId]: members,
        },
      };
    case REMOVE_COMPANY_MEMBER_TAG:
      // eslint-disable-next-line no-case-declarations
      const membersNew = state.company_members[action.payload.companyId].map(
        (member) => {
          if (member.slack_id === action.payload.slack_id)
            member.tags = member.tags.filter(
              (tag) => tag.id !== action.payload.data
            );
          return member;
        }
      );
      return {
        ...state,
        company_members: {
          ...state.company_members,
          [action.payload.companyId]: membersNew,
        },
      };

    default:
      return state;
  }
};

export default companiesReducer;
